import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowClockwise } from '@phosphor-icons/react';

function UpdateNotification({ show, onUpdate }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999]"
          data-testid="update-notification"
        >
          <div className="bg-navy text-white rounded-lg shadow-lg px-5 py-3 flex items-center gap-3">
            <ArrowClockwise size={18} weight="bold" className="animate-spin" style={{ animationDuration: '2s' }} />
            <span className="text-sm font-medium">A new version is available</span>
            <button
              onClick={onUpdate}
              className="bg-white text-navy font-semibold text-xs px-3 py-1.5 rounded-md hover:bg-slate-100 transition-colors"
              data-testid="update-now-btn"
            >
              Update now
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default UpdateNotification;
